import type { MarkChargebackMode, PPAccountIntegration } from '../types/paymentProcessor';

export function getMarkChargebackMode(account: PPAccountIntegration): MarkChargebackMode {
  if (!account.markChargebackEnabled) return 'off';
  return account.markChargebackDryRun ? 'read_only' : 'mark';
}
